export const priceData = [
  {
    type: "b2c",
    typeDesc: "price.b2cTip",
    marks: {
      1: 1000,
      2: 2500,
      3: 5000,
      4: 8000,
      5: 10000,
      6: 20000,
      7: "20000+",
      // 7: 50000,
      // 8: 100000,
    },
    min: 1,
    max: 7,
    free: [
      { min: 1, max: 1000, price: "free", disable: false },
      { min: 1000, max: 2500, price: "free", disable: false },
      { min: 2500, max: 5000, price: "free", disable: false },
      { min: 5000, max: 8000, price: "free", disable: false },
      { min: "--", max: "--", price: "free", disable: true },
      { min: "--", max: "--", price: "free", disable: true },
      { min: "--", max: "--", price: "free", disable: true },
      // { min: "--", max: "--", price: "free", disable: true },
    ],
    developer: [
      { min: 1, max: 1000, price: 99, disable: false },
      { min: 1000, max: 2500, price: 248, disable: false },
      { min: 2500, max: 5000, price: 495, disable: false },
      { min: 5000, max: 8000, price: 990, disable: false },
      { min: 8000, max: 10000, price: 990, disable: false },
      { min: 10000, max: 20000, price: 1980, disable: false },
      { min: 20000, max: "20000+", price: "contact", disable: false },
      // { min: "--", max: "--", price: 1980, disable: true },
    ],
    developerPro: [
      { min: 1, max: 1000, price: 990, disable: false },
      { min: 1000, max: 2500, price: 2099, disable: false },
      { min: 2500, max: 5000, price: 3899, disable: false },
      { min: 5000, max: 8000, price: 6899, disable: false },
      { min: 8000, max: 10000, price: 6899, disable: false },
      { min: 10000, max: 20000, price: 12299, disable: false },
      { min: 20000, max: "20000+", price: "contact", disable: false },
      // { min: 50000, max: 100000, price: 42999, disable: false },
    ],
    features: {
      developer: [
        "price.priceList.b2c.develop.function.item1",
        "price.priceList.b2c.develop.function.item2",
        "price.priceList.b2c.develop.function.item3",
      ],
      developerPro: [
        "price.priceList.b2c.developPro.function.item1",
        "price.priceList.b2c.developPro.function.item2",
        "price.priceList.b2c.developPro.function.item3",
        "price.priceList.b2c.developPro.function.item4",
        "price.priceList.b2c.developPro.function.item5",
      ],
      enterprise: [
        "price.priceList.b2c.enterprise.function.item1",
        "price.priceList.b2c.enterprise.function.item2",
        "price.priceList.b2c.enterprise.function.item3",
        "price.priceList.b2c.enterprise.function.item4",
        "price.priceList.b2c.enterprise.function.item5",
      ],
    },
  },
  {
    type: "b2b",
    typeDesc: "我想为我的 B 端客户提供更好的身份认证体验",
    marks: {
      1: 200,
      2: 500,
      3: 1000,
      4: 2500,
      5: 5000,
      6: 10000,
      7: "10000+",
      // 8: 50000,
      // 9: 100000,
    },
    min: 1,
    max: 7,
    free: [
      { min: 1, max: 200, price: "free", disable: false },
      { min: "--", max: "--", price: "free", disable: true },
      { min: "--", max: "--", price: "free", disable: true },
      { min: "--", max: "--", price: "free", disable: true },
      { min: "--", max: "--", price: "free", disable: true },
      { min: "--", max: "--", price: "free", disable: true },
      { min: "--", max: "--", price: "free", disable: true },
      { min: "--", max: "--", price: "free", disable: true },
      { min: "--", max: "--", price: "free", disable: true },
    ],
    developer: [
      { min: "--", max: "--", price: 2999, disable: false },
      { min: 1, max: 500, price: 2999, disable: false },
      { min: 500, max: 1000, price: 4799, disable: false },
      { min: 1000, max: 2500, price: 10499, disable: false },
      { min: 2500, max: 5000, price: 17999, disable: false },
      { min: 5000, max: 10000, price: 31999, disable: false },
      { min: 10000, max: "10000+", price: "contact", disable: false },
      // { min: "--", max: "--", price: 49899, disable: true },
      // { min: "--", max: "--", price: 49899, disable: true },
    ],
    developerPro: [
      { min: "--", max: "--", price: 4999, disable: false },
      { min: 1, max: 500, price: 4999, disable: false },
      { min: 1, max: 1000, price: 8990, disable: false },
      { min: 1000, max: 2500, price: 19899, disable: false },
      { min: 2500, max: 5000, price: 34999, disable: false },
      { min: 5000, max: 10000, price: 62999, disable: false },
      { min: 10000, max: "10000+", price: "contact", disable: false },
      // { min: 20000, max: 50000, price: 239999, disable: false },
      // { min: 50000, max: 100000, price: 374999, disable: false },
    ],
    features: {
      developer: [
        "price.priceList.b2b.develop.function.item1",
        "price.priceList.b2b.develop.function.item2",
        "price.priceList.b2b.develop.function.item3",
        "price.priceList.b2b.develop.function.item4",
      ],
      developerPro: [
        "price.priceList.b2b.developPro.function.item1",
        "price.priceList.b2b.developPro.function.item2",
        "price.priceList.b2b.developPro.function.item3",
        "price.priceList.b2b.developPro.function.item4",
        "price.priceList.b2b.developPro.function.item5",
      ],
      enterprise: [
        "price.priceList.b2b.enterprise.function.item1",
        "price.priceList.b2b.enterprise.function.item2",
        "price.priceList.b2b.enterprise.function.item3",
        "price.priceList.b2b.enterprise.function.item4",
        "price.priceList.b2b.enterprise.function.item5",
        "price.priceList.b2b.enterprise.function.item6",
      ],
    },
  },
  {
    type: "b2e",
    typeDesc: "我想为企业员工管理身份",
    marks: {
      1: 10,
      2: 50,
      3: 100,
      4: 150,
      5: 200,
      6: "200+",
    },
    min: 1,
    max: 6,
    free: [
      { min: 1, max: 10, price: "free", disable: false },
      { min: "--", max: "--", price: "free", disable: true },
      { min: "--", max: "--", price: "free", disable: true },
      { min: "--", max: "--", price: "free", disable: true },
      { min: "--", max: "--", price: "free", disable: true },
      { min: "--", max: "--", price: "free", disable: true },
    ],
    developer: [
      { min: "--", max: "--", price: 699, disable: false },
      { min: 1, max: 50, price: 699, disable: false },
      { min: 50, max: 100, price: 1099, disable: false },
      { min: 100, max: 150, price: 1499, disable: false },
      { min: 150, max: 200, price: 1699, disable: false },
      { min: 200, max: "200+", price: "contact", disable: false },
    ],
    features: {
      developer: [
        "price.priceList.b2e.develop.function.item1",
        "price.priceList.b2e.develop.function.item2",
        "price.priceList.b2e.develop.function.item3",
        "price.priceList.b2e.develop.function.item4",
        "price.priceList.b2e.develop.function.item5",
      ],
      enterprise: [
        "price.priceList.b2e.enterprise.function.item1",
        "price.priceList.b2e.enterprise.function.item2",
        "price.priceList.b2e.enterprise.function.item3",
        "price.priceList.b2e.enterprise.function.item4",
        "price.priceList.b2e.enterprise.function.item5",
        "price.priceList.b2e.enterprise.function.item6",
      ],
    },
  },
];
export const newPriceData = [
  {
    type: "b2c",
    typeDesc: "price.b2cTip",
    marks: {
      1: 1000,
      2: 2500,
      3: 5000,
      4: 10000,
      5: "10000+",
      // 5: 20000,
      // 6: "20000+",
    },
    min: 1,
    max: 5,

    developer: [
      {
        min: 1,
        max: 1000,
        priceByMonth: 99,
        priceByYear: 990,
        originalPrice: 1188,
        disable: false,
      },
      {
        min: 1000,
        max: 2500,
        priceByMonth: 248,
        priceByYear: 2475,
        originalPrice: 2970,
        disable: false,
      },
      {
        min: 2500,
        max: 5000,
        priceByMonth: 495,
        priceByYear: 4950,
        originalPrice: 5940,

        disable: false,
      },
      {
        min: 5000,
        max: 10000,
        priceByMonth: 990,
        priceByYear: 9900,
        originalPrice: 11880,
        disable: false,
      },
      // {
      //   min: 10000,
      //   max: 20000,
      //   priceByMonth: 1980,
      //   priceByYear: 19800,
      //   originalPrice: 23760,

      //   disable: false,
      // },
      {
        min: 10000,
        max: "10000+",
        priceByMonth: "contact",
        priceByYear: "contact",
        originalPrice: "contact",
        disable: false,
      },
      // { min: "--", max: "--", price: 1980, disable: true },
    ],
    developerPro: [
      {
        min: 1,
        max: 1000,
        priceByMonth: 990,
        priceByYear: 9900,
        originalPrice: 11880,
        disable: false,
      },
      {
        min: 1000,
        max: 2500,
        priceByMonth: 2099,
        priceByYear: 20990,
        originalPrice: 25188,
        disable: false,
      },
      {
        min: 2500,
        max: 5000,
        priceByMonth: 3899,
        priceByYear: 38990,
        originalPrice: 46788,
        disable: false,
      },
      {
        min: 5000,
        max: 10000,
        priceByMonth: 6899,
        priceByYear: 68990,
        originalPrice: 82788,
        disable: false,
      },
      // {
      //   min: 10000,
      //   max: 20000,
      //   priceByMonth: 12299,
      //   priceByYear: 122990,
      //   originalPrice: 147588,
      //   disable: false,
      // },
      // {
      //   min: 20000,
      //   max: 20000,
      //   priceByMonth: 12299,
      //   priceByYear: 122990,
      //   originalPrice: 147588,
      //   disable: false,
      // },
      {
        min: 10000,
        max: "10000+",
        priceByMonth: "contact",
        priceByYear: "contact",
        originalPrice: "contact",
        disable: false,
      },
      // { min: 50000, max: 100000, price: 42999, disable: false },
    ],
    features: {
      developer: [
        "price.priceList.b2c.develop.function.item1",
        "price.priceList.b2c.develop.function.item2",
        "price.priceList.b2c.develop.function.item3",
      ],
      developerPro: [
        "price.priceList.b2c.developPro.function.item1",
        "price.priceList.b2c.developPro.function.item2",
        "price.priceList.b2c.developPro.function.item3",
        "price.priceList.b2c.developPro.function.item4",
        "price.priceList.b2c.developPro.function.item5",
      ],
      enterprise: [
        "price.priceList.b2c.enterprise.function.item1",
        "price.priceList.b2c.enterprise.function.item2",
        "price.priceList.b2c.enterprise.function.item3",
        "price.priceList.b2c.enterprise.function.item4",
        "price.priceList.b2c.enterprise.function.item5",
        {
          title: "price.priceList.b2c.enterprise.function.item6",
          link: "/solutions/private-cloud",
          tag: true,
        },
      ],
    },
  },
  {
    type: "b2b",
    typeDesc: "price.b2bTip",
    marks: {
      1: 500,
      2: 1000,
      3: "1000+",
      // 3: 2500,
      // 4: 5000,
      // 5: 10000,
      // 6: "10000+",
      // 8: 50000,
      // 9: 100000,
    },
    min: 1,
    max: 3,

    developer: [
      {
        min: 1,
        max: 500,
        priceByMonth: 2999,
        priceByYear: 29990,
        originalPrice: 35988,
        disable: false,
      },
      {
        min: 500,
        max: 1000,
        priceByMonth: 4799,
        priceByYear: 47990,
        originalPrice: 57588,
        disable: false,
      },
      // {
      //   min: 1000,
      //   max: 2500,
      //   priceByMonth: 10499,
      //   priceByYear: 104990,
      //   originalPrice: 125988,
      //   disable: false,
      // },
      // {
      //   min: 2500,
      //   max: 5000,
      //   priceByMonth: 17999,
      //   priceByYear: 179990,
      //   originalPrice: 215998,
      //   disable: false,
      // },
      // {
      //   min: 5000,
      //   max: 10000,
      //   priceByMonth: 31999,
      //   priceByYear: 319990,
      //   originalPrice: 383988,
      //   disable: false,
      // },
      // {
      //   min: 10000,
      //   max: 10000,
      //   priceByMonth: 31999,
      //   priceByYear: 319990,
      //   originalPrice: 383988,
      //   disable: false,
      // },
      {
        min: 1000,
        max: "1000+",
        priceByMonth: "contact",
        priceByYear: "contact",
        originalPrice: "contact",
        disable: false,
      },
    ],
    developerPro: [
      {
        min: 1,
        max: 500,
        priceByMonth: 4999,
        priceByYear: 49990,
        originalPrice: 59988,
        disable: false,
      },
      {
        min: 500,
        max: 1000,
        priceByMonth: 8999,
        priceByYear: 89990,
        originalPrice: 107880,
        disable: false,
      },
      // {
      //   min: 1000,
      //   max: 2500,
      //   priceByMonth: 19899,
      //   priceByYear: 198990,
      //   originalPrice: 238788,
      //   disable: false,
      // },
      // {
      //   min: 2500,
      //   max: 5000,
      //   priceByMonth: 34999,
      //   priceByYear: 349990,
      //   originalPrice: 419988,
      //   disable: false,
      // },
      // {
      //   min: 5000,
      //   max: 10000,
      //   priceByMonth: 62999,
      //   priceByYear: 629990,
      //   originalPrice: 755988,
      //   disable: false,
      // },
      // {
      //   min: 10000,
      //   max: 10000,
      //   priceByMonth: 62999,
      //   priceByYear: 629990,
      //   originalPrice: 755988,
      //   disable: false,
      // },
      {
        min: 1000,
        max: "1000+",
        priceByMonth: "contact",
        priceByYear: "contact",
        originalPrice: "contact",
        disable: false,
      },
    ],
    features: {
      developer: [
        {
          title: "price.priceList.b2b.develop.function.item1",
          des: "price.priceList.b2b.develop.function.item1.description",
        },

        "price.priceList.b2b.develop.function.item2",
        "price.priceList.b2b.develop.function.item3",
        "price.priceList.b2b.develop.function.item4",
      ],
      developerPro: [
        {
          title: "price.priceList.b2b.developPro.function.item1",
          des: "price.priceList.b2b.developPro.function.item1.description",
        },

        "price.priceList.b2b.developPro.function.item2",
        "price.priceList.b2b.developPro.function.item3",
        "price.priceList.b2b.developPro.function.item4",
        "price.priceList.b2b.developPro.function.item5",
      ],
      enterprise: [
        "price.priceList.b2b.enterprise.function.item1",
        "price.priceList.b2b.enterprise.function.item2",
        "price.priceList.b2b.enterprise.function.item3",
        "price.priceList.b2b.enterprise.function.item4",
        "price.priceList.b2b.enterprise.function.item5",
        {
          title: "price.priceList.b2c.enterprise.function.item6",
          link: "/solutions/private-cloud",
          tag: true,
        },
      ],
    },
  },
  {
    type: "b2e",
    typeDesc: "price.b2eTip",
    marks: {
      1: 50,
      2: 100,
      3: "100+",
      // 3: 150,
      // 4: 200,
      // 5: "200+",
    },
    min: 1,
    max: 3,

    developer: [
      {
        min: 1,
        max: 50,
        priceByMonth: 699,
        priceByYear: 6990,
        originalPrice: 8388,
        disable: false,
      },
      {
        min: 50,
        max: 100,

        priceByMonth: 1099,
        priceByYear: 10990,
        originalPrice: 13188,

        disable: false,
      },
      // {
      //   min: 100,
      //   max: 150,

      //   priceByMonth: 1499,
      //   priceByYear: 14990,
      //   originalPrice: 17988,

      //   disable: false,
      // },
      // {
      //   min: 150,
      //   max: 200,
      //   priceByMonth: 1699,
      //   priceByYear: 16990,
      //   originalPrice: 20388,

      //   disable: false,
      // },
      // {
      //   min: 200,
      //   max: 200,
      //   priceByMonth: 1699,
      //   priceByYear: 16990,
      //   originalPrice: 20388,
      //   disable: false,
      // },
      {
        min: 200,
        max: "200+",
        priceByMonth: "contact",
        priceByYear: "contact",
        originalPrice: "contact",
        disable: false,
      },
    ],
    features: {
      developer: [
        "price.priceList.b2e.develop.function.item1",
        "price.priceList.b2e.develop.function.item2",
        "price.priceList.b2e.develop.function.item3",
        "price.priceList.b2e.develop.function.item4",
        "price.priceList.b2e.develop.function.item5",
      ],
      enterprise: [
        "price.priceList.b2e.enterprise.function.item1",
        "price.priceList.b2e.enterprise.function.item2",
        "price.priceList.b2e.enterprise.function.item3",
        "price.priceList.b2e.enterprise.function.item4",
        "price.priceList.b2e.enterprise.function.item5",
        {
          title: "price.priceList.b2c.enterprise.function.item6",
          link: "/solutions/private-cloud",
          tag: true,
        },
      ],
    },
  },
];
